<script>
    import { closeModal } from "svelte-modals";
    import { fly } from "svelte/transition";
    import toast from "svelte-french-toast";
    import SelectableGroupTree from "../Cards/Group/SelectableGroupTree.svelte";
    import Button from "../Button/Button.svelte";
    import { adoptCircles } from "../../services/groupService";

    export let isOpen;
    export let groupId = undefined;
    export let groupName = "";
    export let onConfirm;
    export let selectedIds = [];
    export let title = "Cambia i circoli";

    let selected = [];
    let isPressed = false;

    function handleSelect(event) {
        selected = event.detail;
    }

    function confirm() {
        if (!selected.length || isPressed) {
            return;
        }

        isPressed = true;

        adoptCircles(groupId, selected.map((c) => c.id)).then((resp) => {
            isPressed = false;

            if (resp.status === 200) {
                toast.success(
                    selected.length === 1
                        ? "Circolo spostato"
                        : `${selected.length} circoli spostati`
                );

                onConfirm?.(selected);
                closeModal();
            }
        }).catch((err) => {
            isPressed = false;
            toast.error(`Impossibile spostare i circoli, errore ${err.toString()}`);
        });
    }
</script>

{#if isOpen}
    <div
        class="large-modal w-11/12 md:w-9/12"
        transition:fly={{ y: -100 }}
        on:introstart
        on:outroend
    >
        <div class="flex flex-col gap-1">
            <div class="text-3xl font-bold">{title}</div>
            <div class="text-xl text-blueGray-500">
                Questa operazione cambierà la disposizione dei circoli.
                Sono selezionabili solo i circoli di altre federazioni. Clicca di nuovo un circolo per deselezionarlo.
            </div>
        </div>

        <div class="tree-area">
            <SelectableGroupTree {groupId}  {selectedIds} on:select={handleSelect} />
        </div>

        <div class="flex flex-col gap-1">
            <div class="font-bold text-lg">
                Circoli selezionati{selected.length ? ` (${selected.length})` : ""}:
            </div>

            <div class="w-full flex flex-wrap items-center gap-2 py-2 max-h-32 overflow-y-auto">
                {#if !selected.length}
                    <div class="w-full flex items-center h-10 text-blueGray-400">Nessun circolo selezionato</div>
                {:else}
                    {#each selected as circle (circle.id)}
                        <div class="py-1 px-3 bg-gray-200 rounded-full w-max">
                            {circle.name}
                        </div>
                    {/each}
                {/if}
            </div>
        </div>

        <div class="flex items-center justify-end gap-4">
            <div class="flex gap-2">
                <Button
                    handleClick={confirm}
                    isDisabled={!selected.length || isPressed}
                    buttonClass="bg-lightBlue-500 text-center font-semibold text-white px-6"
                    content="Conferma"
                />

                <Button
                    handleClick={closeModal}
                    buttonClass="bg-blueGray-600 text-center font-semibold text-white px-6"
                    content="Annulla"
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .large-modal {
        border-radius: 5px;
        padding: 15px;
        position: fixed;
        background-color: white;
        z-index: 85;
        left: 50%;
        top: 3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 1rem;
        translate: -50%;
        overflow-y: auto;
        max-height: 85%;
    }

    .tree-area {
        height: 32rem;
        width: 100%;
    }
</style>
